//https://www.youtube.com/watch?v=u3KlatzB7GM
import {createSlice} from "@reduxjs/toolkit";
import {useSelector} from "react-redux";

//  this showed how to create the reducer
// https://stackoverflow.com/questions/68971771/react-redux-toolkit-action-in-dispatch-returns-err-object-is-not-a-functi

// const initialState = {value: {id: 0, mcode: "", name:"", description: ""}};

export const workQueueSlice = createSlice({
    name: 'workQueueSlc',
    initialState: {value: {cId: 0, cMcode: null, cName: null, cDescription: null,
            csId: 0, csName: null,
            cdpId: 0, dataType: null,
            workQueueCDPAllCS: true,
            dataPointId: null,
            value: null,

            // moused contract
            mousedContractSeriesId: null,
            mousedContractSeasonId: null,
            mousedContractPropertyId: null,
            mousedContractId: null,
            mousedContractGuild: null,
            mousedContractLaborGroup: null,
            mousedContractContractLevel: null,
            mousedContractStatus: null,
            mousedContractHierarchy: null,
            mousedContractHierarchyNew: null,
            mousedContractExceptionType: null,
            mousedContractGroupedStatus: null,
            mousedContractComboStatus: null,
            mousedContractContractList: null,
            mousedContractName: null,
            mousedContractContractIdArray: [],

            // drawer controls
            workQueueDrawerState: false,
            workQueueDrawerRefresh: false,
            cdpDrawerMode: null,

            // advance controls
            triggerAdvance: false,
            workQueueAdvanceState: false,

            myContractList: null,
            contractHeaderState: false,

            workQueueNewState: false,
            workQueueCDPEditState: false,

            workQueueExpressionState: false,

            workQueueLeftPanelState: 'contracts',

            //contract controls
            workQueueCGridState: true,
            workQueueCGridRefresh: false,
            workQueueCGridAbstractRefresh: false,

            // contract section controls
            workQueueCSGridRefresh: false,
            workQueueCSGridState: false,

            // cdp controls
            workQueueCDPGridRefresh: false,

            workQueueFinalize: false,

            // pencil controls
            workQueueCDPGridPencil: "all",
            workQueueParentCDPGridPencil: "all",

            // pivot

            selectedAttributeDataPointId: null,
            selectedAttributeDataPointName: null,
            selectedVersionNumber: null,
            selectedAttributeId: null,
            cdpvPivotRefresh: false,
            cdpvPivotState: false,
            cdpvMegaPivotRefresh: false,
            cdpvMegaPivotState: false,
            cdpvMegaDatePivotRefresh: false,
            cdpvMegaDatePivotState: false,


            // header
            methodTabsState: true,
            propertySearchState: true,
            unstructuredSearchState: false,
            statsViewState: false,
            refreshPropertyDropdown: false,

            // bulk edit
            bulkEditSeriesId:  null,
            bulkEditSeasonId:  null,
            bulkEditPropertyId: null,
            bulkEditLaborGroup: null,
            bulkEditGuild: null,
            bulkEditContractId: null,
            bulkEditContractLevel: null,
            bulkEditGridPencil: "red",
            refreshBulkEditGrid: false,
            bulkEditGridState: false,

            // cards
            refreshCards: false,
            cardsState: false,

            // this field does not appear to be in use
            workQueueCDPGridFolder: null,

            // experience

            workQueueExperience: null,
            firstTimeSetup: false,

            // friendly top red
            topRedCdpId: null,
            topRedCdpvId: null,
            topRedDataPointId: null,
            topRedDataPointName: null,
            topRedDataType: null,
            topRedDataValue: null,
        topRedMissingCount: null,
            fetchTopLevel: false,
            newSetupContractId: null,
            workQueueCdpPanelRefresh: false,

            // property dropdown list
            propertyDropdownTitleId: 0,
            propertyDropdownTitle: null,
            propertyDropdownMultiSingle: null,
            propertyDropdownExpansionDepth: null,
            propertyDropdownListState: false,

            // selected contract
            selectedContractId: 0,
            selectedContractName: null,
            selectedContractLevel: null,
            selectedContractProductId: null,
            selectedContractType: null,
            selectedContractGuild: null,
            selectedContractFailedExpressionCount: null,
            selectedContractFailedFilterCount: null,
            selectedContractInputMissingCount: null,
            selectedContractPropertyId: 0,
            selectedContractStatus: null,
            selectedContractDescription: null,
            selectedContractDisplayFolders: false,

            // selected contract section
            selectedContractSectionId: 0,
            selectedContractSectionHierarchy: null,

            // selected cdp

            selectedCdpId: 0,
            selectedCdpDataPointId: 0,
            selectedCdpDataPointName: null,
            selectedCdpMockValue: null,
            selectedCdpDataType: null,
            selectedCdpValue: null,
            selectedCdpOriginalValue: null,
            selectedCdpMockOrigin: null,
            selectedCdpDefaultValue: null,
            selectedCdpDefaultValueSource: null,
            selectedCdpDisplayDefaultValue: null,
            selectedCdpDefaultValueValue: null,
            selectedCdpDisplayDefaultValueValue: null,

            // action menu

            actionMenuContractId: 0,
            actionMenuName: null,
            actionMenuContractLevel: null,
            actionMenuProductId: null,
            actionMenuGuild: null,
            actionMenuFailedExpressionCount: null,
            actionMenuFailedFilterCount: null,
            actionMenuInputMissingCount: null,
            actionMenuAction: null,
            actionMenuState: false,

            // contract expand

            contractExpandHierarchical: false,
            contractExpand: false,
            contractExpandMultiSingle: null,
            contractExpandSeriesId: null,
            contractExpandSeasonId: null,
            contractExpandSeasonNumber: null,
            contractExpandProductId: null,
            contractExpandContractType: null,
            contractExpandParticipationsTemplate: null,
            contractExpandLaborGroup: null,
            contractExpandGuild: null,
            contractExpandOption: null,
            contractExpandCast: null,
            contractExpandContractLevel: null,

            // guild multi-select
            guildMultiSelectState: false,
            productGuildDialogueState: false,

            // test scenario
            testScenarioPeriodEnd: null,
            testScenarioDefaultPropertyId: null,
            testScenarioDefaultPropertyName: null,
            testScenarioList: null,
            testScenarioNumber: null,
            testScenarioName: null,
            testScenarioMaxNumber: null,
            testScenarioSelectedNumber: null,

            // displays
            bigAddButtonDisplay: true,
            contractFoldersDisplay: false,
            contractHierarchyDisplay: false,
            cdpListDisplay: false,


    }},

    reducers:
        // {
        //     changeWorkQueue: (state, action) => {
        //         state.value = action.payload;
        //     },
        // }
{
    changeWorkQueue: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeWorkQueue } = workQueueSlice.actions;

export default  workQueueSlice.reducer ;
